module.exports = __webpack_public_path__ + "img/jp.be04fd89.svg";